module.exports = __webpack_public_path__ + "static/media/sbf-website-view-1.860b35a2.png";